import { $connectPlatformQuery } from '@/entities/navigation/store'
import { ConnectPlatform } from '@/features/connectPlatform'
import { useHideNav } from '@/shared/hooks/useHideNav'
import { useUnit } from 'effector-react'
import { BackgroundShading } from '@/shared/ui/backgroundShading'
import { Icon } from '@/shared/ui/icon'
import { useStyles } from './styles'
import { $userLanguage, $userSteamAuthUrl, $userToken } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { goToMain } from '@/app/routing/events'
import { getFarcanaAuthLinkFx } from '@/entities/integration/model/effects'
import { useState } from 'react'
import { GamedDataUsage } from '@/shared/ui/gamedDataUsage'
import OpenEgsGuide from '@/features/howToOpenEgs'
import { getEpicConnectFx } from '@/entities/platforms/egs/effects'
import { getXboxConnect } from '@/entities/platforms/xbox'
export const ConnectPlatformView = () => {
  useHideNav()
  const platform = useUnit($connectPlatformQuery)
  // const platform = 'egs'
  const userLang = useUnit($userLanguage)
  const loginPage = useUnit($userSteamAuthUrl)
  const userToken = useUnit($userToken)

  const { classes } = useStyles()
  const texts = lang[userLang].pages.connectPlatform

  const [isLoginPageLoading, setIsLoginPageLoading] = useState(false)
  const [isDataUsageOpen, setDataUsageOpen] = useState(false)

  const handleConnectSteam = async () => {
    setIsLoginPageLoading(true)
    window.location.href = loginPage!
    setTimeout(() => {
      setIsLoginPageLoading(false)
    }, 3000)
  }

  const handleConnectFarcana = async () => {
    try {
      setIsLoginPageLoading(true)
      if (!userToken) throw new Error('User token is not defined')
      const link = await getFarcanaAuthLinkFx(userToken)
      window.location.href = link.redirect_uri!
    } catch (err) {
      console.error(err)
    } finally {
      setTimeout(() => {
        setIsLoginPageLoading(false)
      }, 3000)
    }
  }

  if (isDataUsageOpen) {
    return <GamedDataUsage onClick={() => setDataUsageOpen(false)} />
  }

  if (platform === 'steam') {
    return (
      <div className={classes.rootWrapper}>
        <img src="/assets/backgrounds/StartBG.webp" alt="" className={classes.startScreenImg} />

        <BackgroundShading width="100%" height="350px" bottom="0" startColor="#00000000" endColor="#000000" />

        <div className={classes.root}>
          <div className={classes.voidInfoWrapper}>
            <span className={classes.infoText}>
              <Icon view="loginInfo" />
              &nbsp;
              {texts.steam.securityAlert}
            </span>
          </div>
          <div className={classes.contentWrapper}>
            <img className={classes.void} src="/assets/backgrounds/Void.webp" alt="" />
            <ConnectPlatform
              platform="steam"
              onConnect={handleConnectSteam}
              onReject={() => goToMain()}
              isLoading={isLoginPageLoading}
              onShowDataInfo={() => setDataUsageOpen(true)}
            />
          </div>
        </div>
      </div>
    )
  }
  if (platform === 'farcana') {
    return (
      <div className={classes.rootWrapper}>
        <img src="/assets/backgrounds/farcanaGameplay.webp" alt="" className={classes.farcanaBg} />

        <BackgroundShading width="100%" height="100px" top="0" upsideDown startColor="#00000000" endColor="#000000" />

        <div className={classes.root}>
          <div className={classes.voidInfoWrapper}>
            <span className={classes.infoText}>
              <Icon view="loginInfo" />
              &nbsp;
              {texts.farcana.securityAlert}
            </span>
          </div>
          <div className={classes.contentWrapper}>
            <img className={classes.gabbyChopped} src="/assets/backgrounds/gabbyChopped.webp" alt="" />
            <ConnectPlatform
              platform="farcana"
              onConnect={handleConnectFarcana}
              onReject={() => {
                goToMain()
              }}
              isLoading={isLoginPageLoading}
            />
          </div>
        </div>
      </div>
    )
  }
  if (platform === 'egs') return <EGS />
  if (platform === 'xbox') return <Xbox />
}

function EGS() {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const userToken = useUnit($userToken)
  const texts = lang[userLang].pages.connectPlatform['egs']

  const [showGuide, setShowGuide] = useState(false)
  function handleGoToOpenEgsGuide() {
    setShowGuide(!showGuide)
  }

  const [isLoading, setIsLoading] = useState(false)
  async function handleConnectEGS() {
    if (!userToken) return
    setIsLoading(true)
    const url = await getEpicConnectFx(userToken)
    window.location.href = url.connect_url
    setTimeout(() => setIsLoading(false), 3000)
  }

  if (showGuide) return <OpenEgsGuide onBack={handleGoToOpenEgsGuide} />

  return (
    <div className={classes.egsRoot}>
      <img src="/assets/backgrounds/egsconnectbg.webp" alt="" className={classes.background} />
      <div className={classes.root}>
        <div className={classes.voidInfoWrapper}>
          <span className={classes.infoText}>
            <Icon view="loginInfo" />
            &nbsp;
            {texts.securityAlert}
          </span>
        </div>
        <div className={classes.contentWrapper}>
          <ConnectPlatform
            platform="egs"
            onConnect={handleConnectEGS}
            onShowDataInfo={handleGoToOpenEgsGuide}
            onReject={() => goToMain()}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  )
}

function Xbox() {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const userToken = useUnit($userToken)
  const [isLoading, setIsLoading] = useState(false)

  const texts = lang[userLang].pages.connectPlatform['xbox']

  const connectXbox = async () => {
    if (!userToken) return
    const url = await getXboxConnect(userToken)
    setIsLoading(true)
    window.location.href = url.connect_url
    setTimeout(() => {
      setIsLoading(false)
    }, 3000)
  }

  return (
    <div className={classes.rootWrapper}>
      <div className={classes.root}>
        <div className={classes.voidInfoWrapper}>
          <span className={classes.infoText}>
            <Icon view="loginInfo" />
            &nbsp;
            {texts.securityAlert}
          </span>
        </div>
        <div className={classes.contentWrapper}>
          <img
            style={{ position: 'absolute', width: '100%', top: '-70%' }}
            src="/assets/backgrounds/xbox-bg.webp"
            alt=""
          />
          <img
            style={{ position: 'absolute', width: '50%', bottom: '120%' }}
            src="/assets/svg/xbox-text-logo.webp"
            alt=""
          />
          <ConnectPlatform platform="xbox" onConnect={connectXbox} onReject={() => goToMain()} isLoading={isLoading} />
        </div>
      </div>
    </div>
  )
}
